module.exports = __webpack_public_path__ + "static/img/zngy_p1.128a5bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/zngy_p1.png
// module id = BKu0
// module chunks = 19